import { DispatchLoading, DispatchType } from "domain/utils/ReactUtils";
import { StoreAplication } from "../main";
import { LOADING_REMOVE, StateType } from "domain/types/base/base";
import { toast, ToastOptions } from 'react-toastify';

//Gere uma função com o toast que aguarde o click do usuario
export async function ToastAwait(message: string = "Clique para continuar"): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
        toast(message, ToastClick((v) => resolve(v), false, true));
    });
}

// eslint-disable-next-line no-unused-vars
export function ToastClick(handleToastClick?: (value : boolean) => void, useRedux: boolean = false, closeButton : boolean = false): ToastOptions {
    const toastId = `toast-${Date.now()}`;

    function openOpen() {
        if (useRedux) {
            StoreAplication.dispatch(
                DispatchLoading(
                    toastId,
                    DispatchType.TOAST,
                    toastId,
                    StateType.Local
                )
            );
        }
    }
    let clicado = false;
    function closeClick(prop : boolean) {
        if(clicado == true){return}
        handleToastClick && handleToastClick(prop);
        if (useRedux) {
            StoreAplication.dispatch(
                {
                    payload: toastId,
                    type: LOADING_REMOVE
                })
        }
    }

    function handleCloseButtonClick() {
        closeClick(false);
        clicado = true;
    }

    const btn = (
        <button 
            onClick={handleCloseButtonClick} 
            style={{
                backgroundColor: "#E83A3A",
                border: "none",
                borderRadius: "5px",
                padding: "5px 10px",
                cursor: "pointer",
                color: "#ffffff",
                fontWeight: "bold",
                boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)"
            }}
        >
            Não
        </button>
    );

    return {
        onClose: ()=>closeClick(false),
        onClick: ()=>{closeClick(true); clicado = true;},
        onOpen: openOpen,
        closeOnClick: true,
        closeButton: closeButton && btn
    } as ToastOptions
}